import { Empty, lucideIcons } from '@round/creatorbase-ui';

import styles from './CreatorTableEmptyState.module.css';

const { SearchX, CircleAlert } = lucideIcons;

type Props = {
    hasError?: boolean;
};

export function CreatorTableEmptyState({ hasError }: Props) {
    return (
        <div className={styles.container}>
            {hasError ? (
                <Empty className={styles.empty}>
                    <Empty.Media variant="icon">
                        <CircleAlert />
                    </Empty.Media>
                    <Empty.Title>Something went wrong</Empty.Title>
                    <Empty.Description>Failed to load creators. Please try again.</Empty.Description>
                </Empty>
            ) : (
                <Empty className={styles.empty}>
                    <Empty.Media variant="icon">
                        <SearchX />
                    </Empty.Media>
                    <Empty.Title>No creators found</Empty.Title>
                </Empty>
            )}
        </div>
    );
}
